import styles from './styles';

const Footer = ({ left, right, classes }) => (
  <div className={classes.root}>
    {left && <div className={classes.secondaryActions}>{left}</div>}
    <div className={classes.actions}>{right}</div>
  </div>
);

Footer.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
